export default "__VITE_ASSET__Cvd1T3Pv__"